export * from './Modal'



// WEBPACK FOOTER //
// ./src/modules/modal/containers/index.ts